<ng-container *transloco="let t">
  <p-panel [showHeader]="false" styleClass="p-panel-no-header p-panel-with-controls">
    <div class="container">
      <div class="icon">
        <i class="fad fa-cloud-question"></i>
      </div>

      <div class="title">{{ t('core.pages.page_not_found.title') }}</div>

      <div class="message">{{ t('core.pages.page_not_found.message') }}</div>

      <div class="buttons">
        <button
          pButton
          type="button"
          icon="fad fa-arrow-left"
          label="{{ t('core.pages.page_not_found.go_back') }}"
          class="p-button-text mr-2"
          (click)="goBack()"
        ></button>

        <button
          pButton
          type="button"
          icon="fa-duotone fa-house"
          label="{{ t('core.pages.page_not_found.home') }}"
          class="p-button-text"
          (click)="goHome()"
        ></button>
      </div>
    </div>
  </p-panel>
</ng-container>
